import React from "react";
import { FormControl } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import "./styles/ImportDropDowns.css";

const ImportDropDown = ({ label, tableHeader, selectProps }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
    >
      <div className="select-label-container">
        <label>{t(`tab2.contents.fields_section.${label}`)}</label>
      </div>

      <div className="select-form-control">
        <FormControl>
          <Select {...selectProps} data-testid="select-dropdown">
            <MenuItem value="">
              <em>Select Items</em>
            </MenuItem>
            {tableHeader &&
              tableHeader.map((ele, key) => {
                return (
                  <MenuItem value={ele} key={key}>
                    {ele}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
export default ImportDropDown;
